<template>
  <div v-if="$is_admin()">
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import Videohub from './external_devices/Videohub.vue'
import Teranex from './external_devices/Teranex.vue'
import PDU from './external_devices/Pdu.vue'
import BottomSheet from '../BottomSheet'
export default {
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/settings/external_devices/videohub'
    },
    {
      path: 'videohub',
      component: Videohub
    },
    {
      path: 'teranex',
      component: Teranex
    },
    {
      path: 'pdu',
      component: PDU
    }

  ],
}
</script>
